var map = {
	"./ar.jpg": "f11b",
	"./de-Latn-DE.jpg": "eea9",
	"./de.jpg": "af77",
	"./en-Latn-US.jpg": "f115",
	"./es-Latn-ES.jpg": "c31c",
	"./fr-Latn-FR.jpg": "2d54",
	"./fr.jpg": "0e67",
	"./id-Latn-ID.jpg": "cfd9",
	"./it.jpg": "2ade",
	"./ja-Jpan-JP.jpg": "a4bf",
	"./pt-Latn-PT.jpg": "90c7",
	"./ru.jpg": "359f",
	"./us.jpg": "b140",
	"./yue-Hant-HK.jpg": "9e14",
	"./zh-Hans-CN.jpg": "18ea",
	"./zh-Hant-HK.jpg": "f08c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3b9f";